import React, { useState } from 'react'
import { Breadcrumb, Row, Col, Button, Card, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SearchBar from '@components/util/SearchBar';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import SelectNewCompanyTable from '@rd-web-markets/shared/dist/company/SelectNewCompanyTable';
import { NEW_COMPANY_NEEDS_COMPANY_NUMBER, USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import SidebarPortal from '@rd-web-markets/shared/dist/util/SidebarPortal';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { kimbleCompanyService } from '@rd-web-markets/shared/dist/services/kimble_company.service';
import CreateCompanyBasedOnSearchTerm from './CreateCompanyBasedOnSearchTerm';
import { goToCreateCompanyForms } from '@rd-web-markets/market/dist/util/new_company_page/goToCreateCompanyForm';

const NewCompanyPage = ({handleToaster}) => {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const [lastSearchedTerm, setLastSearchedTerm] = useState('')

  const handleSearch = async e => {
    setLoading(true);
    try { 
      const response = await kimbleCompanyService.all(e);
      setCompanies(response);
      setLastSearchedTerm(e)
    } catch(error) {
      dispatch(handleError(error));
    }
    setLoading(false);
  }

  const setCompanyNumber = async (companyNumber, index) => {
    if(companyNumber.length === 8) {
      setLoading(true)
      try {
        const newCompanies = [...companies];
        newCompanies[index] = {...companies[index], number: companyNumber};
        setCompanies(newCompanies);
      } catch(er) { 
        handleToaster('There is no match for the Companies House number you have entered please  review and try again.', 'warning')
      } finally {
        setLoading(false);
      }

    } else { 
      handleToaster('Company Number must be 8 digits', 'warning');
    }
  }


  /**
   * onSelect={goToCreateCompanyForms} - whether company number selection is needed depends on the market
   * it is controlled by showSetCompanyNumber
   */
  const renderCompanies = (
    <Col md={{span: 6, offset: 3}}>
      <SelectNewCompanyTable
        showSetCompanyNumber={NEW_COMPANY_NEEDS_COMPANY_NUMBER}
        companies={companies}
        onSelect={goToCreateCompanyForms}
        onSetCompanyNumber={setCompanyNumber}
        user={user}
      />
    </Col>
  )
  return (
    <>
      {!USE_V2_DESIGN && <SidebarPortal headerItem={{link: 'companies', text: 'Companies'}} />}
      {!USE_V2_DESIGN && (
        <BreadcrumbsPortal>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${user.account_type}`}}>{t('home')}</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${user.account_type}/companies`}}>{t('companies')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('new')}</Breadcrumb.Item>
          </Breadcrumb>
        </BreadcrumbsPortal>
      )}

      <Row className={USE_V2_DESIGN ? 'justify-content-center mx-0 mt-4' : ''}>
        <Col md={USE_V2_DESIGN ? 10 : 12}>
          {USE_V2_DESIGN && <h1 className='fw-bold mb-3' style={{ color: '#0078B9' }}>{t('new_company')}</h1>}
          <Card>
            {!USE_V2_DESIGN && (
              <Card.Header className="bg-primary bg-gradient text-white">{t('new_company')}</Card.Header>
            )}
            <Card.Body>
              <Row>
                <Col md={{span: 6, offset: 3}}>
                  <SearchBar
                    placeholder={t('start_typing_company_name_to_begin')}
                    onSubmit={handleSearch}
                    loading={loading} />
                </Col>
                {companies.length > 0 && (renderCompanies)}

                 {window.MARKET_CONSTANTS.SHOULD_CREATE_NOT_FOUND_SEARCHED_COMPANY && (
                  <CreateCompanyBasedOnSearchTerm 
                    lastSearchedTerm={lastSearchedTerm}
                    companies={companies}
                    user={user}
                  />
                 )}
              </Row>
            </Card.Body>
            <Card.Footer>
              <Row>
                <Col md={6} className="text-start">
                  <Button as={Link} variant="light" to={`/${user.account_type}/companies/`}>
                    <span className="material-icons md-18">chevron_left</span> {t('back')}
                  </Button>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default NewCompanyPage
